import util from "@/libs/util";
export default {
  name: "app",
  data: function data() {
    return {
      version: '1.0.1'
    };
  },
  watch: {
    "$i18n.locale": "i18nHandle"
  },
  created: function created() {
    console.log('created:', this.version);
    this.i18nHandle(this.$i18n.locale);
  },
  methods: {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set("lang", val);
      document.querySelector("html").setAttribute("lang", val);
    }
  }
};